import { z } from 'zod';
export const HealthResponse = z.object({
    status: z.literal('ok'),
    uptimeSeconds: z.number().int().nonnegative(),
    timestamp: z.string().datetime({ offset: true }),
});
export const ReadinessStatus = z.enum(['ready', 'degraded']);
export const ReadinessChecks = z.object({
    db: z.boolean(),
    redis: z.boolean(),
});
export const ReadinessResponse = z.object({
    status: ReadinessStatus,
    checks: ReadinessChecks,
    timestamp: z.string().datetime({ offset: true }),
});
//# sourceMappingURL=responses.js.map